import React from 'react';
import { Route } from 'react-router-dom';
import { AccessTokensView } from '.';

export const AccessTokensRoutes = () => (
  <>
    <Route exact path='/my-profile/access-tokens' component={AccessTokensView} />
  </>
);
